export type DomainUmbrella = 'mecha' | 'infra';

export interface Domain {
  umb: DomainUmbrella;
  umbLabel: string;
  name: string;
  blurb: string;
  keys: string[];
  img: string;
}

export const DOMAINS: Domain[] = [
  {
    umb: 'mecha',
    umbLabel: 'Mechatronics',
    name: 'Technical Partner',
    blurb:
      "Skilled engineering talent embedded on-site with Japan's leading manufacturers — keeping production lines running across automotive, semiconductor and precision industries.",
    keys: ['Skilled engineers', 'Automotive', 'Semiconductor'],
    img: 'assets/domains/partner.jpg',
  },
  {
    umb: 'mecha',
    umbLabel: 'Mechatronics',
    name: 'Factory Automation',
    blurb:
      'Vision-based inspection and automated production-line solutions, built on decades of image-processing know-how — lifting throughput and quality for manufacturers nationwide.',
    keys: ['Vision inspection', 'Line automation', 'Smart factory'],
    img: 'assets/domains/factory.jpg',
  },
  {
    umb: 'infra',
    umbLabel: 'Critical Infrastructure',
    name: 'Lifeline',
    blurb:
      "Power, civil engineering and disaster-resilience services for the systems Japan can't afford to lose — built on long-running relationships with utilities and the public sector.",
    keys: ['Electric', 'Civil', 'Disaster resilience'],
    img: 'assets/domains/lifeline.jpg',
  },
  {
    umb: 'infra',
    umbLabel: 'Critical Infrastructure',
    name: 'Plant',
    blurb:
      'Plant engineering, maintenance and turnaround services for chemical, energy and process industries — the high-skill work that quietly keeps society running.',
    keys: ['Plant maintenance', 'Turnaround', 'Process industry'],
    img: 'assets/domains/plant.jpg',
  },
];
